import { render, staticRenderFns } from "./GroupProfile.vue?vue&type=template&id=04a847b8&scoped=true"
import script from "./GroupProfile.vue?vue&type=script&lang=js"
export * from "./GroupProfile.vue?vue&type=script&lang=js"
import style0 from "./GroupProfile.vue?vue&type=style&index=0&id=04a847b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a847b8",
  null
  
)

export default component.exports